/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authcallbacksigningin3Inputs */

const en_authcallbacksigningin3 = /** @type {(inputs: Authcallbacksigningin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing you in…`)
};

const pt_authcallbacksigningin3 = /** @type {(inputs: Authcallbacksigningin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A iniciar sessão…`)
};

/**
* | output |
* | --- |
* | "Signing you in…" |
*
* @param {Authcallbacksigningin3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authcallbacksigningin3 = /** @type {((inputs?: Authcallbacksigningin3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authcallbacksigningin3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authcallbacksigningin3(inputs)
	return pt_authcallbacksigningin3(inputs)
});
export { authcallbacksigningin3 as "authCallbackSigningIn" }